var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-m":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('div',{staticClass:"ct-chart"},[_c('canvas',{attrs:{"id":"myChart"}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }